module.exports = "<my-title my-label=\"$root.labels.account.titles.accounts\"\n  my-style=\"$root.styles.titles.center\"\n  my-level=\"3\">\n</my-title>\n\n<my-tables my-data=\"$$account.data.currents\"\n  my-nature=\"'account'\"\n  enable-buttons=\"authService.isAdmin()\">\n</my-tables>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/account/templates/consult.html
// module id = 1475
// module chunks = 0